import React, { useEffect, useState } from "react";
import ParticlesAuth from "../../AuthenticationInner/ParticlesAuth";
import { Card, CardImg, CardImgOverlay, Container } from "reactstrap";
import Home from "../Component/Home/Page/Home";
import BookNow from "../Component/BookingNow/BookNow";
import About from "../Component/AboutUs/About";
import TouristAttractions from "../Component/Coursel/TouristAttractions";
import bg from "../../../assets/images/Travel/bg.png";
import TestimonialCarousel from "../Component/Testimonials/Component/TestimonialCarousel";
import TravelLinkService from "../../../services/TravelLinkService/TravelLinkService";
import { useLoading } from "../../../Context/LoadingContext";
import { Helmet } from "react-helmet";
import MetaHelmet from "../../../Components/Common/DynamicMetaHelmet/MetaHelmet";

const MainPage = () => {
  const [homeData, setHomeData] = useState({});
  const { fullLoading, setLoadingState } = useLoading();
  const packageTitle = "Some Popular Trips";

  // Fetch data for the page
  const fetchData = async () => {
    // setLoadingState(true);
    try {
      const response = await TravelLinkService.getHome();
      setHomeData(response);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      // setLoadingState(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // document.title="Home-Travel Link Services"
  return (
    <>
      <MetaHelmet
        meta_description={homeData?.home?.meta_description}
        meta_title={homeData?.home?.meta_title}
        keyword={homeData?.home?.name}
      />
      {/* {fullLoading ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "100vh" }}
        >
          <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      ) : (
        <> */}
      <Home />
      <Container fluid>
        <BookNow data={homeData} packageTitle={packageTitle} />
        <About homeData={homeData} />
        <TouristAttractions homeData={homeData} />
        <div className="d-flex justify-content-center align-items-center mb-3">
          <h1>Testimonials</h1>
        </div>
        <TestimonialCarousel homeData={homeData} />
      </Container>
      {/* </>
      )} */}
    </>
  );
};

export default MainPage;
